import React from 'react';
import ReactDOM from 'react-dom';
import DialogComponent from './DialogComponent';
import { observer as globalObserver } from '../../../common/utils/observer';

export default class Dialog {
    constructor(id, title, content, options = {}) {
        this.componentId = `${id}-component`;

        const mountNode = $(`#${id}`)[0];
        if (!mountNode) {
            // Mount node missing from page markup. Skip render instead of letting
            // ReactDOM throw "#200 target container is not a DOM element", which —
            // when a Dialog is constructed at module load — aborts the whole bundle
            // and leaves the page blank. One missing dialog must not kill the app.
            // eslint-disable-next-line no-console
            console.warn(`[Dialog] mount node #${id} not found in DOM; dialog "${id}" disabled.`);
            return;
        }

        ReactDOM.render(<DialogComponent id={this.componentId} title={title} content={content} options={options} />, mountNode);
    }
    open() {
        $(`#${this.componentId}`).dialog('open');
        globalObserver.emit('dialog.opened', this.componentId);
    }
    close() {
        $(`#${this.componentId}`).dialog('close');
    }
    registerCloseOnOtherDialog() {
        globalObserver.register('dialog.opened', dialogId => {
            if (dialogId !== this.componentId) {
                this.close();
            }
        });
    }
}
